import { checkBrowserSupport, initWithPerformanceProfile, handleReducedMotion, enhanceAccessibility, initLogoGrid, initAllEngagementGrids, cleanup } from '../utils/illustrations';

export default function initIllustrations() {
  const gridHero = document.getElementById('logo-grid');
  const otherAnimations =  document.querySelectorAll(".circles-grid");
  const loaderWrap = document.querySelector('.loader-wrap');
  
  checkBrowserSupport();
  initWithPerformanceProfile();
  handleReducedMotion();
  enhanceAccessibility();
  if(gridHero || otherAnimations.length) {
    
    if(gridHero) {
      if(!loaderWrap){
        initLogoGrid();
      }
    }
    if(otherAnimations) {
      initAllEngagementGrids(otherAnimations);
    }

    cleanup();
  }
}